import { Fade } from "react-awesome-reveal";
import { Link } from "react-router-dom";

import { useMain } from "@/contexts/mainContext";

import { Button } from "./ui/button";

interface HomeCardProps {
  bgImage?: string;
  bgColor: string;
  hoverBgColor: string;
  iconColor: string;
  icon: "icon1" | "icon2" | "icon3";
  text: string;
  textColor: string;
  hoverTextColor?: string;
  borderColor: string;
  btnText: string;
  link: string;
  time: number;
}

export function HomeCard({
  bgImage,
  bgColor,
  hoverBgColor,
  text,
  textColor,
  hoverTextColor,
  borderColor,
  btnText,
  link,
  time,
}: HomeCardProps) {
  const { setSuccess } = useMain();

  return (
    <div
      className="relative z-0 flex min-h-[600px] flex-col items-center justify-center overflow-hidden bg-center py-12 max-[768px]:bg-top lg:h-screen lg:py-0 min-[1450px]:bg-[-90px_90px] min-[1500px]:bg-[center_90px]"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundColor: "white",
      }}
    >
      <div
        className={`absolute inset-0 ${bgColor} z-0 ${!bgColor.includes("white") ? "mix-blend-multiply" : "opacity-90"}`}
      />
      <div className="relative z-10 flex flex-col items-center justify-center gap-12 min-[1450px]:top-[50px] min-[1920px]:top-[150px]">
        <Fade delay={time}>
          {/* <div
            className={`${iconColor} flex h-48 w-48 items-center justify-center rounded-full`}
          >
            <img
              src={icon === "icon1" ? icon1 : icon === "icon2" ? icon2 : icon3}
              className="h-28 w-28"
              alt={text}
            />
          </div> */}
          <h1
            className={`${textColor} whitespace-pre-wrap text-center font-roboto text-3xl font-bold`}
          >
            {text}
          </h1>
          <Link to={`${link}`} onClick={() => setSuccess(false)}>
            <Button
              variant="transparent"
              size="lg"
              className={`${borderColor} ${textColor} ${hoverBgColor} ${hoverTextColor} font-roboto text-xl font-medium hover:border-transparent`}
            >
              {btnText}
            </Button>
          </Link>
        </Fade>
      </div>
    </div>
  );
}
